import { useTheme } from "../ThemeContext";
import styles from "./QuestionsModule.module.css";
import { Collapse } from "react-bootstrap";
export function QuestionCard({
  header,
  description,
  isOpened,
  setOpened,
  index,
}) {
  const { s, toggleTheme } = useTheme();

  const rotated = isOpened;
  function openCard() {
    setOpened((curIndex) => (index === curIndex ? null : index));
  }
  return (
    <>
      <style>{`.plus {
    position: relative;
    width: 30px;
    height: 30px;
    margin-left: auto;
    margin-right: 8px;
    transition: transform 0.3s ease-in-out;
    transform-origin: center center;
  }
  
  .plus::before,
  .plus::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    width: 20px; /* Длина линии */
    height: 2px; /* Толщина линии */
    background-color: ${s.navIconsColor}; /* Цвет линии, можно заменить нужным */
    transform: translate(-50%, -50%);
  }
  
  /* Вертикальная линия поворачиваем на 90 градусов */
  .plus::after {
    transform: translate(-50%, -50%) rotate(90deg);
  }`}</style>
      <div
        className={`${
          isOpened ? styles.questionCardOpened : styles.questionCard
        } ps-3 pt-2 pb-2`}
        onClick={openCard}
        style={{ cursor: "pointer", ...s.cardBg, ...s.cardHeader }}
      >
        <div style={{ width: "90%" }}>{header}</div>
        <div
          className={`plus ${rotated ? styles.rotated : ""}`}
          // style={{ color: s.navIconsColor }}
        ></div>
      </div>

      <Collapse in={isOpened}>
        <div>
          <div
            className={`${styles.questionCardMenu} ps-3 pe-2`}
            style={{ ...s.cardBg, ...s.cardDescr }}
            onClick={openCard}
          >
            {description}
          </div>
        </div>
      </Collapse>
    </>
  );
}

export function QuestionBlock({ header, description, linkText, link }) {
  const { s, toggleTheme } = useTheme();

  return (
    <div className={styles.questionBlock} style={s.cardBg}>
      <h4 className={styles.questionBlockHeader} style={s.cardHeader}>
        {header}
      </h4>
      <p className={styles.questionBlockDescr} style={s.cardDescr}>
        {description}
      </p>
      <a className={styles.questionBlockLink} href={link}>
        {linkText}
      </a>
    </div>
  );
}
